import loadView from "@/utils/load-view";
import { getListSegment, getListCustomFilter } from "@/utils/parse-goals-query";

const routes = [
    {
        path: "/goals",
        redirect: "/goals/list/user",
        name: "Goals",
        component: loadView("Goals"),
        props: to => ({
            queryTeams: to.query?.localTeams?.split(",") ?? [],
            queryTags: to.query?.tags?.split(",") ?? [],
            queryCycles: to.query?.cycles?.split(",") ?? [],
            queryStates: to.query?.states?.split(",") ?? [],
            queryAdmin: to.query?.admin?.split(",") ?? [],
            querySearch: to.query?.search ?? "",
        }),
        children: [
            // CREATE
            {
                path: "/goals/create",
                name: "GoalsCreate",
                component: loadView("GoalsCreate"),
                meta: {
                    authRequired: true,
                },
            },
            // DETAILS
            {
                path: "/goals/details/:id",
                name: "GoalsDetails",
                component: loadView("GoalsDetails"),
                props: true,
                meta: {
                    authRequired: true,
                    resolvers: [
                        () => ({ type: "jira/getStatus" }),
                        to => ({ type: "goals/goals/getDetails", payload: { id: to.params.id } }),
                        to => ({
                            type: "goals/comments/getList",
                            payload: { goalId: to.params.id },
                        }),
                    ],
                },
            },
            // EDIT
            {
                path: "/goals/edit/:id",
                name: "GoalsEdit",
                component: loadView("GoalsDetails"),
                props: true,
                meta: {
                    authRequired: true,
                    modal: true,
                    resolvers: [
                        () => ({ type: "goals/cycles/getList" }),
                        () => ({ type: "jira/getStatus" }),
                        () => ({
                            type: "users/list/get",
                            payload: {
                                userFilter: { include: { admin: [{ _id: "directTeam" }] } },
                            },
                        }),
                        () => ({ type: "tags/search/findByName", payload: { query: "" } }),
                        to => ({
                            type: "goals/search/findByName",
                            payload: { exclude: to.params.id },
                        }),
                        to => ({ type: "goals/goals/getDetails", payload: { id: to.params.id } }),
                    ],
                },
            },

            // CYCLES
            {
                path: "/goals/cycles/list",
                name: "GoalsCyclesList",
                component: loadView("GoalsCyclesList"),
                meta: {
                    authRequired: true,
                    resolvers: [() => ({ type: "goals/cycles/getList" })],
                },
            },
            {
                path: "/goals/cycles/create",
                name: "GoalsCyclesCreate",
                component: loadView("GoalsCyclesCreate"),
                meta: {
                    authRequired: true,
                    resolvers: [() => ({ type: "tags/search/findByName" })],
                },
            },
            {
                path: "/goals/cycles/details/:id",
                name: "GoalsCyclesDetails",
                component: loadView("GoalsCyclesDetails"),
                props: true,
                meta: {
                    authRequired: true,
                    resolvers: [
                        to => ({ type: "goals/cycles/get", payload: { id: to.params.id } }),
                    ],
                },
            },
            {
                path: "/goals/cycles/edit/:id",
                name: "GoalsCyclesEdit",
                component: loadView("GoalsCyclesEdit"),
                props: true,
                meta: {
                    authRequired: true,
                    resolvers: [
                        to => ({ type: "goals/cycles/get", payload: { id: to.params.id } }),
                        () => ({ type: "tags/search/findByName" }),
                    ],
                },
            },

            // LIST - STATS - FEED - TREE
            {
                path: "/goals/list/:segment",
                name: "GoalsList",
                component: loadView("GoalsList"),
                props: true,
                meta: {
                    authRequired: true,
                    resolvers: [
                        to => {
                            const listSegment = getListSegment(to.params.segment);
                            const listCustomFilter = getListCustomFilter(to.query);
                            const output = "list";

                            return {
                                type: "goals/goals/getList",
                                payload: { listSegment, listCustomFilter, output },
                            };
                        },
                    ],
                },
            },
            {
                path: "/goals/stats/:segment",
                name: "GoalsStats",
                component: loadView("GoalsStats"),
                props: true,
                meta: {
                    authRequired: true,
                    resolvers: [
                        to => {
                            const listSegment = getListSegment(to.params.segment);
                            const listCustomFilter = getListCustomFilter(to.query);
                            const output = "stats";

                            return {
                                type: "goals/goals/getList",
                                payload: { listSegment, listCustomFilter, output },
                            };
                        },
                    ],
                },
            },
            {
                path: "/goals/feed/:segment",
                name: "GoalsFeed",
                component: loadView("GoalsFeed"),
                props: true,
                meta: {
                    authRequired: true,
                    resolvers: [
                        to => {
                            const listSegment = getListSegment(to.params.segment);
                            const listCustomFilter = getListCustomFilter(to.query);
                            const output = "feed";

                            return {
                                type: "goals/goals/getList",
                                payload: { listSegment, listCustomFilter, output },
                            };
                        },
                    ],
                },
            },
            {
                path: "/goals/tree/:segment",
                name: "GoalsTree",
                component: loadView("GoalsTree"),
                props: true,
                meta: {
                    authRequired: true,
                    resolvers: [
                        to => {
                            const listSegment = getListSegment(to.params.segment);
                            const listCustomFilter = getListCustomFilter(to.query);
                            const output =
                                to.params.segment === "all" &&
                                (!Object.keys(listCustomFilter).length ||
                                    !listCustomFilter.filterSet)
                                    ? "treeFull"
                                    : "treePartial";

                            return {
                                type: "goals/goals/getList",
                                payload: { listSegment, listCustomFilter, output },
                            };
                        },
                    ],
                },
            },
        ],
    },
];

export default routes;
